import { ReactNode } from 'react';

import { Tooltip, TooltipProps, useTheme } from '@mui/material';

import { TooltipContentRow, TooltipIconWrapper } from './TooltipWithIcon.styles';

interface TooltipWithIconProps extends Omit<TooltipProps, 'title'> {
  icon: ReactNode;
  text: ReactNode;
}

export const TooltipWithIcon = ({
  icon,
  text,
  children,
  componentsProps,
  ...tooltipProps
}: TooltipWithIconProps) => {
  const theme = useTheme();

  return (
    <Tooltip
      {...tooltipProps}
      componentsProps={{
        ...componentsProps,
        tooltip: {
          ...componentsProps?.tooltip,
          sx: { bgcolor: theme.palette.red[500], ...componentsProps?.tooltip?.sx },
        },
        arrow: {
          ...componentsProps?.arrow,
          sx: { color: theme.palette.red[500], ...componentsProps?.arrow?.sx },
        },
      }}
      title={
        <TooltipContentRow>
          <TooltipIconWrapper>{icon}</TooltipIconWrapper>
          {text}
        </TooltipContentRow>
      }
    >
      {children}
    </Tooltip>
  );
};

export default TooltipWithIcon;
